import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import "./authInfo.scss";
import { httpOnlySecurityService } from "../../externals/iam";
import { faUserAlt } from "@fortawesome/free-solid-svg-icons/faUserAlt";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons/faSignOutAlt";

const Authenticated = () => {
  const [menuOpen, setMenuOpen] = React.useState(false);

  const handleClickMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleKeyDownMenu = (event) => {
    if (event.key === "Enter") {
      handleClickMenu();
    }
  };

  const handleLogout = async () => {
    if (httpOnlySecurityService.isTokenExpired()) {
      try {
        await httpOnlySecurityService.refresh();
        httpOnlySecurityService.logout();
      } catch (error) {
        // showBoundary(new Error("REFRESH_TOKEN_ERROR"));
        console.error("REFRESH_TOKEN_ERROR", error);
      }
    } else {
      httpOnlySecurityService.logout();
    }
  };

  const handleKeyDownLogout = async (event) => {
    if (event.key === "Enter") {
      await handleLogout();
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (event.target.closest(".auth-info") !== null || !menuOpen) {
        return;
      }
      setMenuOpen(false);
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape" && menuOpen) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [menuOpen]);

  return (
    <div className="auth-info">
      <div
        className="icon-container"
        role="button"
        aria-label="User's menu"
        tabIndex="0"
        onClick={handleClickMenu}
        onKeyDown={handleKeyDownMenu}
      >
        <FontAwesomeIcon icon={faUserAlt} className="icon" />
      </div>
      {menuOpen ? (
        <ul className="auth-info-context-menu" role="menu">
          <li
            className="choice"
            role="menuitem"
            aria-label="sign out"
            tabIndex="0"
            onClick={handleLogout}
            onKeyDown={handleKeyDownLogout}
          >
            <div className="label">
              <FormattedMessage id="app.signOut" />
            </div>
            <FontAwesomeIcon icon={faSignOutAlt} />
          </li>
        </ul>
      ) : null}
    </div>
  );
};

export function AuthInfoComponent() {
  return httpOnlySecurityService.isUserAuthenticated() ? (
    <Authenticated />
  ) : null;
}

export default AuthInfoComponent;
